/**
* stories.js
* @author      : HUANGXI
* @description : 视频链接
* @created     : 2020-12-08 11:28:05
* @modified    : 2020-12-23 16:20:19
*/

export const VIDEO_SRC = [
  {
    key: 'E6',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E5%85%AD%E9%9B%86%E5%B0%81%E9%9D%A2.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%ABEP06clean.mp4'
  },
  {
    key: 'E5',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E4%BA%94%E9%9B%86%E5%B0%81%E9%9D%A2.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%ABEP05clean.mp4'
  },
  {
    key: 'E4',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E5%9B%9B%E9%9B%86%E5%B0%81%E9%9D%A2.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%ABEP04clean.mp4'
  },
  {
    key: 'E3',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E4%B8%89%E9%9B%86%E5%B0%81%E9%9D%A2_%E6%9B%B4%E6%96%B0.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%ABEP03cleanHLnobanner.mp4'
  },
  {
    key: 'E2',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E4%BA%8C%E9%9B%86%E5%B0%81%E9%9D%A2_%E6%9B%B4%E6%96%B0.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%AB%E6%88%91%E5%80%91%E7%9A%84%E6%95%85%E4%BA%8BEP2Highlightw_obanner.mp4'
  },
  {
    key: 'E1',
    title: '中國移動香港特約：5G改寫我們的故事',
    cover: 'https://mylink.oss-accelerate.aliyuncs.com/7home/%E7%AC%AC%E4%B8%80%E9%9B%86%E5%B0%81%E9%9D%A2_%E6%9B%B4%E6%96%B0.png',
    src: 'https://mylink.oss-accelerate.aliyuncs.com/7home/5G%E6%94%B9%E5%AF%AB%E6%88%91%E5%80%91%E7%9A%84%E6%95%85%E4%BA%8BEP1.mp4'
  }
]

export const SHARE_INFO = {
  title: '中國移動香港特約：5G改寫我們的故事',
  content: '由大灣區5G產業聯盟協助拍攝的「中國移動香港特約：5G改寫我們的故事」以不同行業因應5G的改變，探討最後如何改變我們的生活為主題，節目包括多位專家訪問，深入淺出地讓您更了解5G與您的關係。'
}


// WEBPACK FOOTER //
// ./src/page/5gRewritesStory/stories.js